import p1_img1 from '../Assets/p1_img1.jpg'
import p4_img1 from '../Assets/p4_img1.avif'
import p6_img1 from '../Assets/p6_img1.webp'
import p9_img1 from '../Assets/p9_img1.webp'

let data_product= [
    {
    id: 1,
    name: "Handloom Cotton Saree with Lotus Motifs and Intricate Border Design",
    image: p1_img1,
    new_price: 7250.00,
    old_price: 8900.00,
    star: 4,
    reviews: 120,
    },
    {
    id: 4,
    name: "Chiffon Long Dress with Flowing Silhouette and Vibrant Floral Prints",
    image: p4_img1, 
    new_price: 5800.00,
    old_price: 7200.00,
    star: 3,
    reviews: 45,
    },
    {
    id: 6,
    name: "Handloom Cotton Saree with Floral Borders and Elegant Pallu",
    image: p6_img1, 
    new_price: 7800.00,
    old_price: 9100.00,
    star: 5,
    reviews: 80,
    },
    {
    id: 9,
    name: "Georgette Saree with Embroidered Motifs and Sheer Pallu",
    image: p9_img1,
    new_price: 9500.00,
    old_price: 11200.00,
    star: 5,
    reviews: 70,
  },

]
export default data_product;;
